import { RootState } from '..'

export const getIsDirty = (state: RootState) => state.dirty.isDirty
